import React from 'react';
import { Link } from 'react-router-dom';

const HomePage: React.FC = () => {
  return (
    <section className="genealogy-section" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, background: '#000' }}>
      <div className="genealogy-card" style={{ maxWidth: 540, width: '100%', textAlign: 'center', background: '#181818', color: '#fff' }}>
        <h1 className="heading-1" style={{ color: '#fff' }}>Genealogy Platform</h1>
        <h2 className="heading-2" style={{ color: '#90ee90', fontWeight: 400, fontSize: '1.25rem', marginBottom: 24 }}>
          Discover, connect, and visualise your family history
        </h2>
        <p style={{ fontSize: 18, color: '#e0e0e0', marginBottom: 36 }}>
          Build your family tree, explore DNA matches, and collaborate on complex relationships—including hypothetical "ghost" ancestors—using advanced, modern tools.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 18, marginBottom: 24 }}>
          <Link to="/tree" className="genealogy-btn-primary" style={{ fontSize: 20, padding: '16px 0', textDecoration: 'none', marginBottom: 8 }}>
            Family Tree
          </Link>
          <Link to="/chromosome-painter" className="genealogy-btn-primary" style={{ fontSize: 20, padding: '16px 0', textDecoration: 'none' }}>
            Chromosome Painter
          </Link>
        </div>
        <div style={{ fontSize: 15, color: '#b0b0b0', marginTop: 18 }}>
          <strong>Tip:</strong> You can add "ghost" ancestors to model DNA-based hypotheses and merge them later if you discover their identity!
        </div>
      </div>
    </section>
  );
};

export default HomePage; 